<template>
  <div class="page-container pagination">
    <a
      class="pagination__item"
      :class="{ 'pagination__item--disabled': articlesPage === 1 }"
      @click="changeArticlesPage(articlesPage - 1)"
    >
      <svg class="pagination__item__icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      <span>
        Pagina {{ articlesPage - 1 }}
      </span>
    </a>
    <a
      class="pagination__item"
      :class="{
        'pagination__item--active'   : articlesPage === number,
        'pagination__item--disabled' : number === 0
      }"
      @click="changeArticlesPage(number)"
      v-for="number of array"
    >
      {{ number === 0 ? '...' : number }}
    </a>
    <a
      class="pagination__item"
      :class="{ 'pagination__item--disabled': articlesPage === articlesPageLast }"
      @click="changeArticlesPage(articlesPage + 1)"
    >
      <span>
        Pagina {{ articlesPage + 1 }}
      </span>
      <svg class="pagination__item__icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => {
    return { widthMax: 11 };
  },
  created() {
    window.addEventListener("resize", this.processWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.processWidth);
  },
  mounted() {
    this.processWidth();
  },
  computed: {
    ...mapGetters({
      articlesPage     : 'articles/articlesPage',
      articlesPageLast : 'articles/articlesPageLast',
    }),

    array() {
      const width      = this.widthMax < 9 ? 1 : 2;
      const widthLeft  = (this.widthMax - width * 2 - 3) >> 1;
      const widthRight = (this.widthMax - width * 2 - 2) >> 1;

      if (this.articlesPageLast <= this.widthMax) {
        return this.range(1, this.articlesPageLast);
      }

      if (this.articlesPage <= this.widthMax - width - 1 - widthRight) {
        const concat = this.range(this.articlesPageLast - width + 1, this.articlesPageLast);
        return this.range(1, this.widthMax - width - 1).concat(0, concat);
      }

      if (this.articlesPage >= this.articlesPageLast - width - 1 - widthRight) {
        const concat = this.range(this.articlesPageLast - width - 1 - widthRight - widthLeft, this.articlesPageLast);
        return this.range(1, width).concat(0, concat);
      }

      return this.range(1, width)
        .concat(0, this.range(this.articlesPage - widthLeft    , this.articlesPage + widthRight),
                0, this.range(this.articlesPageLast - width + 1, this.articlesPageLast));
    },
  },
  methods: {
    ...mapActions({
      changeArticlesPage: 'articles/changeArticlesPage',
    }),

    range(start, end) {
      return Array.from(Array(end - start + 1), (_, i) => i + start);
    },

    processWidth() {
        if (window.innerWidth > 1200) {
        return this.widthMax = 11;
      }

      if (window.innerWidth > 990) {
        return this.widthMax = 11;
      }

      if (window.innerWidth > 770) {
        return this.widthMax = 9;
      }

      if (window.innerWidth > 640) {
        return this.widthMax = 7;
      }

      return this.widthMax = 5;
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  align-items: center;
  display: flex;
  justify-content: space-between;

  @include media-breakpoint-up(sm) {
    justify-content: center;
  }

  &__item {
    align-items: center;
    background: $color-light-gray;
    color: $color-gray;
    cursor: pointer;
    display: none;
    font-size: 20px;
    font-weight: 700;
    height: 50px;
    justify-content: center;
    margin-right: 20px;
    min-width: 50px;
    text-decoration: none;
    transition: 200ms background, 200ms color;

    @include media-breakpoint-up(sm) {
      display: flex;
    }

    /* &--active, */
    &:first-child,
    &:last-child {
      display: flex;
    }

    &:last-child {
      margin-right: 0;
    }

    &:not(&--disabled):hover {
      background: rgba($color-light-gray, 0.8);
    }

    &--active {
      color: $color-light;
      background: $color-primary !important;
    }

    &--disabled {
      background: rgba($color-light-gray, 0.4);
      cursor: not-allowed;
      padding: 0 !important;

      & > span {
        display: none;
        padding: 0 !important;
      }
    }

    &:first-child {
      padding-left: 10px;
    }

    &:last-child {
      padding-left: 20px;
      padding-right: 10px;
    }

    &:first-child > span {
      padding-left: 5px;
      padding-right: 20px;
      white-space: nowrap;
    }

    &:last-child > span {
      padding-right: 5px;
      white-space: nowrap;
    }

    @include media-breakpoint-up(sm) {
      &:first-child,
      &:last-child {
        padding: 0;
      }

      & > span {
        display: none;
        padding: 0;
      }
    }
  }
}
</style>
